const register = {
  loginCredentials: "Διαπιστευτήρια σύνδεσης", // translated
  companyInformation: "Στοιχεία της εταιρείας", // translated
  contactDetails: "Στοιχεία επικοινωνίας", // translated
  businessName: "Επωνυμία Επιχείρησης", // translated
  businessAddress: "Διεύθυνση επιχείρησης", // translated
  registrationCode: "Κωδικός εγγραφής", // translated
  businessRegistrationNumber: "Αριθμός επιχειρηματικής εγγραφής", // translated
  websiteUrl: "Διεύθυνση Ιστοσελίδας", // translated
  mobilePhone: "Κινητό τηλέφωνο", // translated
  regionStateProvince: "Περιφέρεια/Πολιτεία/Επαρχία", // translated
  legalTitle: "Νομικός Τίτλος", // translated
  city: "Πόλη", // translated
  postalCode: "Ταχυδρομικός Κώδικας", // translated
  registrationSuccess: "Επιτυχία εγγραφής.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Περιμένετε λίγα λεπτά και θα ανακατευθυνθείτε στην αρχική σελίδα.", // translated
  usernameEmail: "Όνομα χρήστη (e-mail)", // translated
  password: "Κωδικός πρόσβασης", // translated
  verifyPassword: "Επιβεβαίωση κωδικού", // translated
  documents: "Έγγραφα", // translated
  termsAndConditionsSection: "Όροι και προϋποθέσεις", // translated
  certificateOfIncorporation: "Πιστοποιητικό σύστασης", // translated
  acceptTermsAndConditions: "Αποδοχή όρων και προϋποθέσεων", // translated
  country: "Χώρα", // translated
  brandName: "Μάρκα", // translated
  register: "Εγγραφή", // translated
  isRequired: "Απαιτείται", // translated
  passwordMin8Chars: "Πρέπει να έχει τουλάχιστον 8 χαρακτήρες", // translated
  passwordRequiresDigit: "Πρέπει να περιέχει τουλάχιστον 1 ψηφίο", // translated
  passwordRequiresLowercase: "Πρέπει να περιέχει τουλάχιστον 1 πεζό γράμμα", // translated
  passwordRequiresUppercase: "Πρέπει να περιέχει τουλάχιστον 1 κεφαλαίο γράμμα", // translated
  passwordRequiresSpecialChar: 'Πρέπει να περιέχει τουλάχιστον 1 ειδικό χαρακτήρα (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "Μεταφόρτωση αρχείου", // translated
  filename: "Όνομα αρχείου:", // translated
  fileType: "Τύπος:", // translated
  fileSize: "Μέγεθος:", // translated
  maxFileSize10Mb: "Μέγ.: 10 MB", // translated
  supportedFileTypes: "Υποστηριζόμενοι τύποι αρχείων:", // translated
  showPassword: "Εμφάνιση κωδικού", // translated
  hidePassword: "Απόκρυψη κωδικού", // translated
  notAvailable: "Μ/Δ", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "π.χ. +306912345678", // translated
  websiteUrlPlaceholder: "http://www.paradeigma.gr", // translated
  loading: "Φόρτωση...", // translated
  uploadingDocument: "Μεταφόρτωση εγγράφου...", // translated
  percentUploaded: "{{percent}}% μεταφορτώθηκε", // translated
  registrationSuccessful: "Η εγγραφή ολοκληρώθηκε.", // translated
  failedToUploadDocument: "Αποτυχία μεταφόρτωσης εγγράφου.", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "Το {{field}} πρέπει να έχει περισσότερους από {{min}} χαρακτήρες", // translated
  fieldMustBeValidEmail: "Το {{field}} πρέπει να είναι έγκυρο e-mail", // translated
  fieldPasswordMinLength: "Το {{field}} πρέπει να έχει τουλάχιστον 8 χαρακτήρες", // translated
  fieldPasswordRequiresDigit: "Το {{field}} πρέπει να περιέχει τουλάχιστον 1 ψηφίο", // translated
  fieldPasswordRequiresLowercase: "Το {{field}} πρέπει να περιέχει τουλάχιστον 1 πεζό γράμμα", // translated
  fieldPasswordRequiresUppercase: "Το {{field}} πρέπει να περιέχει τουλάχιστον 1 κεφαλαίο γράμμα", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} πρέπει να περιέχει τουλάχιστον 1 ειδικό χαρακτήρα (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "Το {{field}} δεν ταιριάζει με το {{otherField}}", // translated
  fieldBetweenLength: "Το {{field}} πρέπει να είναι μεταξύ {{min}} και {{max}} χαρακτήρων", // translated
  postalCodeBetweenLength: "Το {{field}} πρέπει να είναι μεταξύ {{min}} και {{max}} χαρακτήρων", // translated
  invalidUrlFormat: "Μη έγκυρη μορφή URL", // translated
  invalidEmailFormat: "Μη έγκυρη μορφή e-mail", // translated
  emailMustMatchUsername: "το e-mail πρέπει να είναι ίδιο με το όνομα χρήστη (e-mail)", // translated
  mobilePhoneIsRequired: "Το κινητό τηλέφωνο είναι υποχρεωτικό", // translated
  certificateFileTooLarge: "Το πιστοποιητικό σύστασης είναι πολύ μεγάλο", // translated
  termsMustBeAccepted: "Οι όροι και προϋποθέσεις πρέπει να γίνουν αποδεκτοί", // translated
};


export default register;
